<a class="card card--no-padding service service--clickable" [routerLink]="routerLink()">
  <div class="service__header">
    <div class="service__left">
      <status-icon [status]="health().status"></status-icon>

      <div class="service__header-caption">
        <alias-editor
          [customerDescription]="customerDescription()"
          [subscriptionId]="subscriptionId()"
          class="list-alias-editor"
        />
        <service-subtitle [subscription]="subscription()" />
        <service-tags [firewallEnabled]="firewallEnabled()" [tags]="tags()" />
      </div>
    </div>
    <div class="service__right">
      <div class="service__button" (click)="openIncidentDialog($event)">
        {{ "Services.Fulfilment.ReportProblem" | translate }}
      </div>
      <div class="service__current">
        <div class="service__current-col">
          <div class="service__current-title">{{ "ServiceElement.Chart.NowIn" | translate }}</div>
          <div>{{ health().in | readable_size }}</div>
        </div>
        <div class="service__current-col">
          <div class="service__current-title">{{ "ServiceElement.Chart.NowOut" | translate }}</div>
          <div>{{ health().out | readable_size }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="service__graph">
    @if (showPortVisualizer()) {
      <port-visualiser [subscription]="subscription()" (selected)="navigateToService($event)" />
    }
  </div>

  @if (serviceDisruption(); as disruption) {
    <service-status
      class="service__status"
      productType="{{ productType() }}"
      subscriptionId="{{ subscriptionId() }}"
      [serviceDisruption]="disruption"
    >
    </service-status>
  }
</a>
